import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import $ from 'jquery';

require('selectize');
const isMobile = require('../web/isMobile');

const fragments = {
  PANE: '[data-fragment="SelectTabs.pane"]',
  SELECT: '[data-fragment="SelectTabs.select"]',
};

export default class SelectTabs extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      activePane: null,
    };
    this.switchTab = this.switchTab.bind(this);
    this.setFromURL = this.setFromURL.bind(this);
  }
  didMount() {
    this.panes = this.element.querySelectorAll(fragments.PANE);
    if (!isMobile.phone && !isMobile.tablet) {
      this.select = $(fragments.SELECT).selectize();
      this.select.on('change', this.switchTab);
    } else {
      this.select = document.body.querySelector(fragments.SELECT);
      this.select.addEventListener('change', this.switchTab);
    }
    this.setFromURL();
  }
  switchTab = (e) => {
    let noneSelected = true;
    for (let i = 0; i < this.panes.length; i++) {
      if (this.panes[i].dataset.value === e.target.value) {
        this.setState({
          activePane: this.panes[i],
        });
        noneSelected = false;
      }
    }
    if (noneSelected) {
      this.setState({
        activePane: null,
      });
    }
  };
  setFromURL = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const inquiryTarget = urlParams.get('frm.inquiryTarget');
    for (let i = 0; i < this.panes.length; i++) {
      if (this.panes[i].dataset.value === inquiryTarget) {
        this.setState({
          activePane: this.panes[i],
        });
      }
    }
  };
  update() {
    const { activePane } = this.state;
    for (let i = 0; i < this.panes.length; i++) {
      this.panes[i].classList.remove('select-tabs__pane--active');
    }
    if (activePane) {
      classNames(activePane, {
        'select-tabs__pane--active': true,
      });
    }
  }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SelectTabs.js